import { subscribeApiEndpoints, versionApiEndpoints } from '@/api/endpoints';
import { ShowAllData, useMutateGetApi } from '@/apiError/apiShow';
import { useFetch } from '@/hooks';
import { enablePaginationOrNot } from '@/utils/common';
import { globalSearch } from '@/utils/search/Search';

import { Button, Card, Col, Input, Row, Switch, Table } from 'antd';
import { useEffect, useState } from 'react';
import { CiSearch } from 'react-icons/ci';
import { Link, useNavigate } from 'react-router-dom';
import { useControlSettings } from './hooks/useControlSettings';
import { DeleteModal } from './deleteModal';
import { render } from '@react-pdf/renderer';
import { AntSwitch } from '@/common/ant-components/AntSwitch';
import { align } from '@progress/kendo-drawing';
import EditControlSettings from './edit-control-settings';

export function ControlSettingsList() {
  const navigate = useNavigate();
  const [searchQuery, setSearchQuery] = useState('');
  const [open, setOpen] = useState(false);
  const [referenceId, setReferenceId] = useState(null);
  const [loading, setLoading] = useState(false);

  // const { data } = useControlSettings(navigate);

  const { mutateAsync, isPending, data } = useMutateGetApi();

  const versions = data?.data || [];

  const Column = [
    {
      title: 'S.N',
      dataIndex: 'index',
      align: 'center',
      key: 'index',
      width: 50,
    },

    {
      title: 'Company Name',
      dataIndex: 'companyName',
      key: 'companyName',
      width: 200,
    },

    {
      title: 'Branch Name',
      dataIndex: 'branchName',
      key: 'branchName',
      width: 100,
    },

    {
      title: 'Date Type',
      dataIndex: 'dateFormatType',
      key: 'dateFormatType',
      align: 'center',
      width: 80,
    },

    {
      title: 'Primary Calc. Type',
      dataIndex: 'primaryCalculationType',
      key: 'primaryCalculationType',
      align: 'center',
      width: 120,
    },

    {
      title: 'Primary Weight',
      dataIndex: 'primaryWeight',
      key: 'primaryWeight',
      align: 'right',
      width: 120,
    },

    {
      title: 'Is Upload Image',
      dataIndex: 'showImage',
      align: 'center',
      key: 'showImage',
      render: (text) => <Switch checked={text || false} />,
      width: 120,
    },

    {
      title: 'Image Limit',
      dataIndex: 'imageMaxCount',
      align: 'right',
      key: 'imageMaxCount',
      width: 120,
    },

    {
      title: 'Action',
      align: 'center',
      width: 100,
      render: (item) => {
        return (
          <>
            <div className="ant-action tw-flex tw-gap-6 tw-justify-center">
              <Link size="medium" className="edit">
                <EditControlSettings
                  EditControlSettings
                  id={item.referenceId}
                  record={item}
                  mutateAsync={mutateAsync}
                />
              </Link>
              {/* <div className="ant-button-delete">
                <DeleteModal id={item.referenceId} />
              </div> */}
            </div>
          </>
        );
      },
    },
  ];

  useEffect(() => {
    mutateAsync({ url: '/superadmin/control-settings/' });
  }, []);

  return (
    <>
      <Card>
        <Row className="mb-4">
          <Col xs={{ span: 24 }} lg={{ span: 24 }}>
            <div className="flex justify-end">
              <div>
                <Input
                  className="header-search"
                  name="query"
                  placeholder="Search Subscriber..."
                  prefix={<CiSearch />}
                  value={searchQuery}
                  onChange={(event) => setSearchQuery(event.target.value)}
                />
              </div>
            </div>
          </Col>
        </Row>

        <Table
          columns={Column}
          loading={isPending}
          // scroll={{ x: true }}
          scroll={{
            x: true,
            y: '75vh',
          }}
          dataSource={
            versions
              ? globalSearch(versions, searchQuery).map((item, index) => {
                  return {
                    ...item,
                    index: index + 1,
                  };
                })
              : []
          }
          bordered
          pagination={false}
        />
      </Card>
    </>
  );
}
